module.exports = __webpack_public_path__ + "img/beauty_bg.346858c7.png";